export enum FloorcareProviderNames {
  NORTH_WEST_APPLIANCE = 'north west appliance repairs ltd',
  EQUINOX = 'equinox',
  EQUINOX_LTD = 'equinox maintenance ltd',
}
